module.exports = __webpack_public_path__ + "img/joinPremium.a5d95233.png";